import { Box } from "@mui/material";
import { FC } from "react";
import { Search } from "./components/Search/Search";

export const BaseListHeader: FC = () => {
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "end", zIndex: 100 }}>
      <Search
        sx={{
          padding: "15px",
          boxSizing: "border-box",
          width: "100%",
          maxWidth: "450px",
        }}
      />
    </Box>
  );
};
